import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { ExaminationActionsService } from '@modules/examination/services/examination-actions.service';
import { ActionButtonsComponent } from '@modules/shared/action-buttons/action-buttons.component';
import { ActionButton } from '@shared/models/menu-actions/action-buttons';
import { MenuActionId } from '@shared/models/menu-actions/menu-action-id.enum';
import { ExaminationsNavigationService } from '../../services/examination-navigation.service';

@Component({
  selector: 'pxc-examination-actions',
  imports: [CommonModule, ActionButtonsComponent],
  templateUrl: './examination-actions.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExaminationActionsComponent {
  private readonly translocoService = inject(TranslocoService);
  readonly actions = inject(ExaminationActionsService).getActions();
  readonly entity$ = inject(ExaminationsNavigationService).selectedExamination$;

  @Input() readonly actionButtons: ActionButton[] = [
    {
      appearance: 'secondary',
      icon: '@tui.pencil',
      actionIds: [MenuActionId.EXAMINATION_EDIT],
      hint: this.translocoService.translate("Modifier l'examen"),
      iconOnly: true,
    },
  ];
}
